import { ref } from 'vue';

/**
 * Set when the very first page couldn't open (the sign-in check or the page's code failed to load, e.g. right after the
 * laptop wakes up). Without it the CMS stays a blank white page; App.vue shows a message with Try again instead.
 */
export const bootError = ref<string | null>(null);
